import React, { useEffect } from 'react';
import NavTagline from '../../../nav-tagline/nav-tagline';
import BodyPassword from '../../../account/BodyPassword';
import Footer from '../../../shared/Footer';

const PasswordChangePreReg = () => {
    useEffect(() => {
        const heading = document.querySelector("h1.form-title");
        if (heading) {
            heading.setAttribute("tabindex", "-1");
            heading.focus();
        }
    }, []);

    return (
    <div className="PasswordChangePreReg">
        <NavTagline />
        <main className="layout-container">
            <div 
                className="container"
                tabIndex="-1"
            >
                <div className="descript-container">
                    <h1 className="form-title g-clr">Change Password</h1>
                    <p>Please take a moment to create your unique password. Use the temporary password from your registration email as your current password.</p>
                </div>
                <BodyPassword />
            </div>
        </main>
        <Footer />
    </div>
    )
};

export default PasswordChangePreReg;
